export default __webpack_public_path__ + "static/media/grid.7f69252b.svg";